import type { UpNextV2WrapperProps } from "./components/UpNextV2Wrapper";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "UpNextV2"*/ "./lazyIndex"), {
    name: "UpNextV2",
});

// actions
export const lazyInitializeUpNextV2: LazyAction<typeof lazyIndex.initializeUpNextV2, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeUpNextV2);

// components
export const UpNextV2: LazyComponent<UpNextV2WrapperProps, unknown, void> = createLazyComponent(lazyModule, m => m.UpNextV2);
